export const TEAMTENDENCY = {
  data: [
    {
      "3PT Points": 39,
      "3PT SQ": 41.87,
      "3PT diff": 2.87,
      "FT Points": 9,
      "FT SQ": 10.49,
      "FT diff": 1.49,
      "Finishing at the Rim Points": 52,
      "Finishing at the Rim SQ": 38.9,
      "Finishing at the Rim diff": -13.1,
      Logos: "Alabama",
      "Midrange Points": 4,
      "Midrange SQ": 3.24,
      "Midrange diff": -0.76,
      "Post-Up Points": 0,
      "Post-Up SQ": 3.07,
      "Post-Up diff": 3.07,
      "Unnamed: 0": 1,
    },
    {
      "3PT Points": 27,
      "3PT SQ": 38.59,
      "3PT diff": 11.59,
      "FT Points": 11,
      "FT SQ": 13.64,
      "FT diff": 2.64,
      "Finishing at the Rim Points": 36,
      "Finishing at the Rim SQ": 29.48,
      "Finishing at the Rim diff": -6.52,
      Logos: "South Dakota St.",
      "Midrange Points": 12,
      "Midrange SQ": 12.42,
      "Midrange diff": 0.42,
      "Post-Up Points": 2,
      "Post-Up SQ": 1.77,
      "Post-Up diff": -0.23,
      "Unnamed: 0": 2,
    },
  ],
};

export const PLAYLOG = [
  {
    Minutes: 19,
    Period: 1,
    Play_run: "post-up on the right block shot missed",
    Players: "Noah Gurley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.73,
    SQ_Points_Over_Average: -0.0687657015,
    SQ_Points_percentile: 0.21,
    Seconds: 42,
    Team: "Alabama",
    "Unnamed: 0": 1,
  },
  {
    Minutes: 19,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Matt Dentlinger",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.31,
    SQ_Points: 0.93,
    SQ_Points_Over_Average: 0.016046441,
    SQ_Points_percentile: 0.4,
    Seconds: 19,
    Team: "South Dakota St.",
    "Unnamed: 0": 2,
  },
  {
    Minutes: 19,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.33,
    SQ_Points: 0.98,
    SQ_Points_Over_Average: -0.0617249496,
    SQ_Points_percentile: 0.46,
    Seconds: 8,
    Team: "Alabama",
    "Unnamed: 0": 3,
  },
  {
    Minutes: 18,
    Period: 1,
    Play_run: "cut drop off pass at basket for layup shot made",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.72,
    SQ_Points: 1.44,
    SQ_Points_Over_Average: -0.0524838811,
    SQ_Points_percentile: 0.83,
    Seconds: 46,
    Team: "South Dakota St.",
    "Unnamed: 0": 4,
  },
  {
    Minutes: 18,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.29,
    SQ_Points: 0.86,
    SQ_Points_Over_Average: 0.0154476558,
    SQ_Points_percentile: 0.33,
    Seconds: 35,
    Team: "Alabama",
    "Unnamed: 0": 5,
  },
  {
    Minutes: 18,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.39,
    SQ_Points: 1.18,
    SQ_Points_Over_Average: 0.1182717713,
    SQ_Points_percentile: 0.64,
    Seconds: 24,
    Team: "Alabama",
    "Unnamed: 0": 6,
  },
  {
    Minutes: 18,
    Period: 1,
    Play_run: "offensive rebound shot made",
    Players: "Charles Bediako",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.61,
    SQ_Points: 1.22,
    SQ_Points_Over_Average: -0.1129555719,
    SQ_Points_percentile: 0.68,
    Seconds: 19,
    Team: "Alabama",
    "Unnamed: 0": 7,
  },
  {
    Minutes: 18,
    Period: 1,
    Play_run: "catches and then drives for off the dribble short midrange jumper shot missed",
    Players: "Alex Arians",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.72,
    SQ_Points_Over_Average: 0.0627318185,
    SQ_Points_percentile: 0.2,
    Seconds: 10,
    Team: "South Dakota St.",
    "Unnamed: 0": 8,
  },
  {
    Minutes: 18,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Gurley",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.33,
    SQ_Points: 0.98,
    SQ_Points_Over_Average: -0.0817282287,
    SQ_Points_percentile: 0.46,
    Seconds: 0,
    Team: "Alabama",
    "Unnamed: 0": 9,
  },
  {
    Minutes: 17,
    Period: 1,
    Play_run: "turnover",
    Players: "Douglas Wilson",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 36,
    Team: "South Dakota St.",
    "Unnamed: 0": 10,
  },
  {
    Minutes: 17,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot blocked",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.18,
    SQ_Points: 0.36,
    SQ_Points_Over_Average: -0.0145776582,
    SQ_Points_percentile: 0.03,
    Seconds: 16,
    Team: "Alabama",
    "Unnamed: 0": 11,
  },
  {
    Minutes: 17,
    Period: 1,
    Play_run: "transition catch and shoot 3 point shot missed",
    Players: "Matt Mims",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.34,
    SQ_Points_Over_Average: 0.4112926343,
    SQ_Points_percentile: 0.77,
    Seconds: 7,
    Team: "South Dakota St.",
    "Unnamed: 0": 12,
  },
  {
    Minutes: 16,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot missed",
    Players: "Keon Ellis",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.73,
    SQ_Points_Over_Average: 0.0542140072,
    SQ_Points_percentile: 0.21,
    Seconds: 40,
    Team: "Alabama",
    "Unnamed: 0": 13,
  },
  {
    Minutes: 16,
    Period: 1,
    Play_run: "hand-off and then drives to the basket shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.52,
    SQ_Points: 1.05,
    SQ_Points_Over_Average: -0.070922245,
    SQ_Points_percentile: 0.53,
    Seconds: 29,
    Team: "South Dakota St.",
    "Unnamed: 0": 14,
  },
  {
    Minutes: 16,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.52,
    SQ_Points: 1.04,
    SQ_Points_Over_Average: 0.0280390017,
    SQ_Points_percentile: 0.52,
    Seconds: 20,
    Team: "Alabama",
    "Unnamed: 0": 15,
  },
  {
    Minutes: 16,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot missed",
    Players: "Alex Arians",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.73,
    SQ_Points_Over_Average: -0.0319564553,
    SQ_Points_percentile: 0.21,
    Seconds: 8,
    Team: "South Dakota St.",
    "Unnamed: 0": 16,
  },
  {
    Minutes: 16,
    Period: 1,
    Play_run: "turnover",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 2,
    Team: "Alabama",
    "Unnamed: 0": 17,
  },
  {
    Minutes: 15,
    Period: 1,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.8,
    SQ_Points: 1.59,
    SQ_Points_Over_Average: 0.1322417826,
    SQ_Points_percentile: 0.91,
    Seconds: 56,
    Team: "South Dakota St.",
    "Unnamed: 0": 18,
  },
  {
    Minutes: 15,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 0.75,
    SQ_Points_Over_Average: -0.0269962405,
    SQ_Points_percentile: 0.23,
    Seconds: 43,
    Team: "Alabama",
    "Unnamed: 0": 19,
  },
  {
    Minutes: 15,
    Period: 1,
    Play_run: "post-up on the left block and drives to the basket fouled",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.71,
    SQ_Points: 1.42,
    SQ_Points_Over_Average: 0.0518582555,
    SQ_Points_percentile: 0.82,
    Seconds: 29,
    Team: "South Dakota St.",
    "Unnamed: 0": 20,
  },
  {
    Minutes: 15,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jd Davison",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.82,
    SQ_Points_Over_Average: -0.093953559,
    SQ_Points_percentile: 0.29,
    Seconds: 12,
    Team: "Alabama",
    "Unnamed: 0": 21,
  },
  {
    Minutes: 15,
    Period: 1,
    Play_run: "transition off the dribble 3 point shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.34,
    SQ_Points_Over_Average: 0.3151970887,
    SQ_Points_percentile: 0.77,
    Seconds: 4,
    Team: "South Dakota St.",
    "Unnamed: 0": 22,
  },
  {
    Minutes: 14,
    Period: 1,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.74,
    SQ_Points: 1.47,
    SQ_Points_Over_Average: 0.0514549094,
    SQ_Points_percentile: 0.85,
    Seconds: 52,
    Team: "Alabama",
    "Unnamed: 0": 23,
  },
  {
    Minutes: 14,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 1.15,
    SQ_Points_Over_Average: 0.236046441,
    SQ_Points_percentile: 0.62,
    Seconds: 35,
    Team: "South Dakota St.",
    "Unnamed: 0": 24,
  },
  {
    Minutes: 14,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Juwan Gary",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.21,
    SQ_Points: 0.63,
    SQ_Points_Over_Average: -0.283953559,
    SQ_Points_percentile: 0.12,
    Seconds: 18,
    Team: "Alabama",
    "Unnamed: 0": 25,
  },
  {
    Minutes: 14,
    Period: 1,
    Play_run: "offensive rebound shot made",
    Players: "Charles Bediako",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.61,
    SQ_Points: 1.22,
    SQ_Points_Over_Average: -0.1129555719,
    SQ_Points_percentile: 0.68,
    Seconds: 12,
    Team: "Alabama",
    "Unnamed: 0": 26,
  },
  {
    Minutes: 14,
    Period: 1,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Luke Appel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.74,
    SQ_Points: 1.47,
    SQ_Points_Over_Average: 0.0122417826,
    SQ_Points_percentile: 0.85,
    Seconds: 1,
    Team: "South Dakota St.",
    "Unnamed: 0": 27,
  },
  {
    Minutes: 13,
    Period: 1,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Darius Miles",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.42,
    SQ_Points: 1.26,
    SQ_Points_Over_Average: 0.0434476209,
    SQ_Points_percentile: 0.71,
    Seconds: 46,
    Team: "Alabama",
    "Unnamed: 0": 28,
  },
  {
    Minutes: 13,
    Period: 1,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Alex Arians",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.35,
    SQ_Points_Over_Average: 0.3009016404,
    SQ_Points_percentile: 0.78,
    Seconds: 27,
    Team: "South Dakota St.",
    "Unnamed: 0": 29,
  },
  {
    Minutes: 13,
    Period: 1,
    Play_run: "runs off screen catch and shoot 3 point shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 1.14,
    SQ_Points_Over_Average: 0.0969456833,
    SQ_Points_percentile: 0.61,
    Seconds: 11,
    Team: "Alabama",
    "Unnamed: 0": 30,
  },
  {
    Minutes: 12,
    Period: 1,
    Play_run: "isolation drives to the left towards the basket shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.47,
    SQ_Points: 0.94,
    SQ_Points_Over_Average: -0.01674179,
    SQ_Points_percentile: 0.41,
    Seconds: 59,
    Team: "Alabama",
    "Unnamed: 0": 31,
  },
  {
    Minutes: 12,
    Period: 1,
    Play_run: "transition catch and shoot 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.41,
    SQ_Points: 1.23,
    SQ_Points_Over_Average: 0.3012926343,
    SQ_Points_percentile: 0.69,
    Seconds: 52,
    Team: "South Dakota St.",
    "Unnamed: 0": 32,
  },
  {
    Minutes: 12,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot made",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.6,
    SQ_Points: 1.2,
    SQ_Points_Over_Average: 0.1880390017,
    SQ_Points_percentile: 0.66,
    Seconds: 42,
    Team: "Alabama",
    "Unnamed: 0": 33,
  },
  {
    Minutes: 12,
    Period: 1,
    Play_run: "transition catch and shoot 3 point shot missed",
    Players: "Zeke Mayo",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.39,
    SQ_Points: 1.16,
    SQ_Points_Over_Average: 0.2312926343,
    SQ_Points_percentile: 0.63,
    Seconds: 34,
    Team: "South Dakota St.",
    "Unnamed: 0": 34,
  },
  {
    Minutes: 12,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot missed",
    Players: "Jd Davison",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.23,
    SQ_Points: 0.69,
    SQ_Points_Over_Average: -0.1537581598,
    SQ_Points_percentile: 0.17,
    Seconds: 8,
    Team: "Alabama",
    "Unnamed: 0": 35,
  },
  {
    Minutes: 12,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot made",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 1.19,
    SQ_Points_Over_Average: 0.1482750504,
    SQ_Points_percentile: 0.65,
    Seconds: 1,
    Team: "Alabama",
    "Unnamed: 0": 36,
  },
  {
    Minutes: 11,
    Period: 1,
    Play_run: "turnover",
    Players: "Baylor Scheierman",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 44,
    Team: "South Dakota St.",
    "Unnamed: 0": 37,
  },
  {
    Minutes: 11,
    Period: 1,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Noah Gurley",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.84,
    SQ_Points: 1.67,
    SQ_Points_Over_Average: 0.2122417826,
    SQ_Points_percentile: 0.93,
    Seconds: 38,
    Team: "Alabama",
    "Unnamed: 0": 38,
  },
  {
    Minutes: 11,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot missed",
    Players: "Charlie Easley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.33,
    SQ_Points: 0.66,
    SQ_Points_Over_Average: -0.0157859928,
    SQ_Points_percentile: 0.15,
    Seconds: 17,
    Team: "South Dakota St.",
    "Unnamed: 0": 39,
  },
  {
    Minutes: 11,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.71,
    SQ_Points_Over_Average: -0.0568880944,
    SQ_Points_percentile: 0.19,
    Seconds: 5,
    Team: "Alabama",
    "Unnamed: 0": 40,
  },
  {
    Minutes: 10,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot made",
    Players: "Alex Arians",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 0.99,
    SQ_Points_Over_Average: 0.0974901227,
    SQ_Points_percentile: 0.47,
    Seconds: 50,
    Team: "South Dakota St.",
    "Unnamed: 0": 41,
  },
  {
    Minutes: 10,
    Period: 1,
    Play_run: "turnover",
    Players: "Noah Gurley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 37,
    Team: "Alabama",
    "Unnamed: 0": 42,
  },
  {
    Minutes: 10,
    Period: 1,
    Play_run: "pick and roll (roll-man) pick and pop short midrange jumper shot made",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.56,
    SQ_Points: 1.13,
    SQ_Points_Over_Average: 0.2754998114,
    SQ_Points_percentile: 0.6,
    Seconds: 23,
    Team: "South Dakota St.",
    "Unnamed: 0": 43,
  },
  {
    Minutes: 10,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: -0.103953559,
    SQ_Points_percentile: 0.28,
    Seconds: 8,
    Team: "Alabama",
    "Unnamed: 0": 44,
  },
  {
    Minutes: 10,
    Period: 1,
    Play_run: "offensive rebound short midrange shot made",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.48,
    SQ_Points: 0.95,
    SQ_Points_Over_Average: 0.0309280388,
    SQ_Points_percentile: 0.43,
    Seconds: 0,
    Team: "Alabama",
    "Unnamed: 0": 45,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "transition catch and shoot 3 point shot missed",
    Players: "Alex Arians",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.48,
    SQ_Points: 1.45,
    SQ_Points_Over_Average: 0.3735179645,
    SQ_Points_percentile: 0.84,
    Seconds: 52,
    Team: "South Dakota St.",
    "Unnamed: 0": 46,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 1.15,
    SQ_Points_Over_Average: 0.236046441,
    SQ_Points_percentile: 0.62,
    Seconds: 46,
    Team: "South Dakota St.",
    "Unnamed: 0": 47,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "transition catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.3,
    SQ_Points: 0.89,
    SQ_Points_Over_Average: -0.1864820355,
    SQ_Points_percentile: 0.36,
    Seconds: 34,
    Team: "Alabama",
    "Unnamed: 0": 48,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "transition and then drives to the basket shot missed",
    Players: "Charlie Easley",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 0.9,
    SQ_Points_Over_Average: 0.0314549094,
    SQ_Points_percentile: 0.37,
    Seconds: 28,
    Team: "South Dakota St.",
    "Unnamed: 0": 49,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.44,
    SQ_Points: 1.31,
    SQ_Points_Over_Average: 0.2482717713,
    SQ_Points_percentile: 0.75,
    Seconds: 21,
    Team: "South Dakota St.",
    "Unnamed: 0": 50,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "turnover",
    Players: "Darius Miles",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 21,
    Team: "Alabama",
    "Unnamed: 0": 51,
  },
  {
    Minutes: 9,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 1.08,
    SQ_Points_Over_Average: 0.2362418402,
    SQ_Points_percentile: 0.56,
    Seconds: 1,
    Team: "South Dakota St.",
    "Unnamed: 0": 52,
  },
  {
    Minutes: 8,
    Period: 1,
    Play_run: "transition catch and shoot 3 point shot made",
    Players: "Darius Miles",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.42,
    SQ_Points: 1.27,
    SQ_Points_Over_Average: 0.0386938142,
    SQ_Points_percentile: 0.72,
    Seconds: 53,
    Team: "Alabama",
    "Unnamed: 0": 53,
  },
  {
    Minutes: 8,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "David Wingett",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 1.09,
    SQ_Points_Over_Average: 0.176046441,
    SQ_Points_percentile: 0.57,
    Seconds: 23,
    Team: "South Dakota St.",
    "Unnamed: 0": 54,
  },
  {
    Minutes: 8,
    Period: 1,
    Play_run: "offensive rebound shot made",
    Players: "Luke Appel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.64,
    SQ_Points: 1.27,
    SQ_Points_Over_Average: -0.0629555719,
    SQ_Points_percentile: 0.72,
    Seconds: 15,
    Team: "South Dakota St.",
    "Unnamed: 0": 55,
  },
  {
    Minutes: 8,
    Period: 1,
    Play_run: "runs off screen catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.26,
    SQ_Points: 0.78,
    SQ_Points_Over_Average: -0.1154828272,
    SQ_Points_percentile: 0.25,
    Seconds: 9,
    Team: "Alabama",
    "Unnamed: 0": 56,
  },
  {
    Minutes: 7,
    Period: 1,
    Play_run: "transition off the dribble 3 point shot made",
    Players: "David Wingett",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.32,
    SQ_Points: 0.97,
    SQ_Points_Over_Average: -0.0548029113,
    SQ_Points_percentile: 0.45,
    Seconds: 57,
    Team: "South Dakota St.",
    "Unnamed: 0": 57,
  },
  {
    Minutes: 7,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.39,
    SQ_Points: 1.18,
    SQ_Points_Over_Average: 0.1182717713,
    SQ_Points_percentile: 0.64,
    Seconds: 38,
    Team: "Alabama",
    "Unnamed: 0": 58,
  },
  {
    Minutes: 7,
    Period: 1,
    Play_run: "pick and roll (roll-man) pick and pop and drives to the basket shot missed",
    Players: "Douglas Wilson",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.72,
    SQ_Points_Over_Average: 0.0029535816,
    SQ_Points_percentile: 0.2,
    Seconds: 19,
    Team: "South Dakota St.",
    "Unnamed: 0": 59,
  },
  {
    Minutes: 6,
    Period: 1,
    Play_run: "hand-off off the dribble 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.24,
    SQ_Points: 0.72,
    SQ_Points_Over_Average: -0.0689861815,
    SQ_Points_percentile: 0.2,
    Seconds: 52,
    Team: "Alabama",
    "Unnamed: 0": 60,
  },
  {
    Minutes: 6,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 1.15,
    SQ_Points_Over_Average: 0.236046441,
    SQ_Points_percentile: 0.62,
    Seconds: 38,
    Team: "South Dakota St.",
    "Unnamed: 0": 61,
  },
  {
    Minutes: 6,
    Period: 1,
    Play_run: "catches and then drives to the left towards the basket shot missed",
    Players: "Luke Appel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.35,
    SQ_Points: 0.7,
    SQ_Points_Over_Average: -0.0293883065,
    SQ_Points_percentile: 0.18,
    Seconds: 29,
    Team: "South Dakota St.",
    "Unnamed: 0": 62,
  },
  {
    Minutes: 6,
    Period: 1,
    Play_run: "turnover",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 24,
    Team: "Alabama",
    "Unnamed: 0": 63,
  },
  {
    Minutes: 6,
    Period: 1,
    Play_run: "cut drop off pass at basket for layup shot made",
    Players: "Zeke Mayo",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.69,
    SQ_Points: 1.37,
    SQ_Points_Over_Average: -0.1224838811,
    SQ_Points_percentile: 0.79,
    Seconds: 6,
    Team: "South Dakota St.",
    "Unnamed: 0": 64,
  },
  {
    Minutes: 6,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot missed",
    Players: "Jd Davison",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.23,
    SQ_Points: 0.69,
    SQ_Points_Over_Average: -0.1537581598,
    SQ_Points_percentile: 0.17,
    Seconds: 0,
    Team: "Alabama",
    "Unnamed: 0": 65,
  },
  {
    Minutes: 5,
    Period: 1,
    Play_run: "isolation drives to the right towards the basket shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.51,
    SQ_Points: 1.02,
    SQ_Points_Over_Average: 0.051446716,
    SQ_Points_percentile: 0.5,
    Seconds: 45,
    Team: "Alabama",
    "Unnamed: 0": 66,
  },
  {
    Minutes: 5,
    Period: 1,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 1.01,
    SQ_Points_Over_Average: 0.0029792793,
    SQ_Points_percentile: 0.49,
    Seconds: 20,
    Team: "South Dakota St.",
    "Unnamed: 0": 67,
  },
  {
    Minutes: 5,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Gurley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: -0.103953559,
    SQ_Points_percentile: 0.28,
    Seconds: 13,
    Team: "Alabama",
    "Unnamed: 0": 68,
  },
  {
    Minutes: 4,
    Period: 1,
    Play_run: "catch and shoot 3 point shot made",
    Players: "David Wingett",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.35,
    SQ_Points_Over_Average: 0.1334476209,
    SQ_Points_percentile: 0.78,
    Seconds: 58,
    Team: "South Dakota St.",
    "Unnamed: 0": 69,
  },
  {
    Minutes: 4,
    Period: 1,
    Play_run: "post-up on the right block and drives to the basket shot made",
    Players: "Noah Gurley",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.69,
    SQ_Points: 1.37,
    SQ_Points_Over_Average: 0.2135423454,
    SQ_Points_percentile: 0.79,
    Seconds: 39,
    Team: "Alabama",
    "Unnamed: 0": 70,
  },
  {
    Minutes: 4,
    Period: 1,
    Play_run: "hand-off off the dribble short midrange jumper shot made",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.59,
    SQ_Points: 1.18,
    SQ_Points_Over_Average: 0.3069322522,
    SQ_Points_percentile: 0.64,
    Seconds: 27,
    Team: "South Dakota St.",
    "Unnamed: 0": 71,
  },
  {
    Minutes: 4,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.32,
    SQ_Points: 0.95,
    SQ_Points_Over_Average: 0.036046441,
    SQ_Points_percentile: 0.43,
    Seconds: 15,
    Team: "Alabama",
    "Unnamed: 0": 72,
  },
  {
    Minutes: 3,
    Period: 1,
    Play_run: "catches and then drives to the left towards the basket shot made",
    Players: "Alex Arians",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.43,
    SQ_Points: 0.86,
    SQ_Points_Over_Average: -0.1074882557,
    SQ_Points_percentile: 0.33,
    Seconds: 55,
    Team: "South Dakota St.",
    "Unnamed: 0": 73,
  },
  {
    Minutes: 3,
    Period: 1,
    Play_run: "post-up on the left block shot missed",
    Players: "Noah Gurley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.44,
    SQ_Points: 0.87,
    SQ_Points_Over_Average: 0.1214072918,
    SQ_Points_percentile: 0.34,
    Seconds: 25,
    Team: "Alabama",
    "Unnamed: 0": 74,
  },
  {
    Minutes: 3,
    Period: 1,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 1.21,
    SQ_Points_Over_Average: 0.296046441,
    SQ_Points_percentile: 0.67,
    Seconds: 12,
    Team: "South Dakota St.",
    "Unnamed: 0": 75,
  },
  {
    Minutes: 2,
    Period: 1,
    Play_run: "post-up on the left block shot missed",
    Players: "Noah Gurley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.42,
    SQ_Points: 0.85,
    SQ_Points_Over_Average: 0.1230531289,
    SQ_Points_percentile: 0.32,
    Seconds: 52,
    Team: "Alabama",
    "Unnamed: 0": 76,
  },
  {
    Minutes: 2,
    Period: 1,
    Play_run: "transition off the dribble 3 point shot missed",
    Players: "Zeke Mayo",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.33,
    SQ_Points: 1,
    SQ_Points_Over_Average: 0.1815018818,
    SQ_Points_percentile: 0.48,
    Seconds: 47,
    Team: "South Dakota St.",
    "Unnamed: 0": 77,
  },
  {
    Minutes: 2,
    Period: 1,
    Play_run: "turnover",
    Players: "Jd Davison",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 40,
    Team: "Alabama",
    "Unnamed: 0": 78,
  },
  {
    Minutes: 2,
    Period: 1,
    Play_run: "turnover",
    Players: "Matt Dentlinger",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 22,
    Team: "South Dakota St.",
    "Unnamed: 0": 79,
  },
  {
    Minutes: 2,
    Period: 1,
    Play_run: "runs off screen catch and shoot short midrange jumper shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 0.79,
    SQ_Points_Over_Average: 0.019995371,
    SQ_Points_percentile: 0.26,
    Seconds: 12,
    Team: "Alabama",
    "Unnamed: 0": 80,
  },
  {
    Minutes: 2,
    Period: 1,
    Play_run: "offensive rebound 3 point shot missed",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.33,
    SQ_Points: 1,
    SQ_Points_Over_Average: 0.1351449984,
    SQ_Points_percentile: 0.48,
    Seconds: 6,
    Team: "Alabama",
    "Unnamed: 0": 81,
  },
  {
    Minutes: 1,
    Period: 1,
    Play_run: "turnover",
    Players: "Noah Freidel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 56,
    Team: "South Dakota St.",
    "Unnamed: 0": 82,
  },
  {
    Minutes: 1,
    Period: 1,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Charles Bediako",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.8,
    SQ_Points: 1.59,
    SQ_Points_Over_Average: 0.1322417826,
    SQ_Points_percentile: 0.91,
    Seconds: 50,
    Team: "Alabama",
    "Unnamed: 0": 83,
  },
  {
    Minutes: 1,
    Period: 1,
    Play_run: "turnover",
    Players: "Baylor Scheierman",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 31,
    Team: "South Dakota St.",
    "Unnamed: 0": 84,
  },
  {
    Minutes: 1,
    Period: 1,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Darius Miles",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.42,
    SQ_Points: 1.26,
    SQ_Points_Over_Average: 0.0434476209,
    SQ_Points_percentile: 0.71,
    Seconds: 21,
    Team: "Alabama",
    "Unnamed: 0": 85,
  },
  {
    Minutes: 1,
    Period: 1,
    Play_run: "turnover",
    Players: "Luke Appel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 5,
    Team: "South Dakota St.",
    "Unnamed: 0": 86,
  },
  {
    Minutes: 0,
    Period: 1,
    Play_run: "pick and roll (roll-man) recieves pass and rolls to basket shot made",
    Players: "Charles Bediako",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.73,
    SQ_Points: 1.46,
    SQ_Points_Over_Average: 0.0366236976,
    SQ_Points_percentile: 0.85,
    Seconds: 55,
    Team: "Alabama",
    "Unnamed: 0": 87,
  },
  {
    Minutes: 0,
    Period: 1,
    Play_run: "post-up on the right block shot made",
    Players: "Luke Appel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.48,
    SQ_Points: 0.96,
    SQ_Points_Over_Average: 0.052802388,
    SQ_Points_percentile: 0.44,
    Seconds: 37,
    Team: "South Dakota St.",
    "Unnamed: 0": 88,
  },
  {
    Minutes: 0,
    Period: 1,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 1,
    SQ_Points_Over_Average: 0.1021248772,
    SQ_Points_percentile: 0.48,
    Seconds: 25,
    Team: "Alabama",
    "Unnamed: 0": 89,
  },
  {
    Minutes: 0,
    Period: 1,
    Play_run: "pick and roll (roll-man) pick and pop 3 point shot missed",
    Players: "Luke Appel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.21,
    SQ_Points: 0.62,
    SQ_Points_Over_Average: 0.0159417429,
    SQ_Points_percentile: 0.12,
    Seconds: 2,
    Team: "South Dakota St.",
    "Unnamed: 0": 90,
  },
  {
    Minutes: 0,
    Period: 1,
    Play_run: "offensive rebound shot missed",
    Players: "Charlie Easley",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.41,
    SQ_Points: 0.82,
    SQ_Points_Over_Average: -0.2129555719,
    SQ_Points_percentile: 0.29,
    Seconds: 0,
    Team: "South Dakota St.",
    "Unnamed: 0": 91,
  },
  {
    Minutes: 20,
    Period: 2,
    Play_run: "turnover",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 0,
    Team: "Alabama",
    "Unnamed: 0": 92,
  },
  {
    Minutes: 19,
    Period: 2,
    Play_run: "cut drop off pass at basket for layup shot made",
    Players: "Alex Arians",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.7,
    SQ_Points: 1.41,
    SQ_Points_Over_Average: -0.0824838811,
    SQ_Points_percentile: 0.81,
    Seconds: 39,
    Team: "South Dakota St.",
    "Unnamed: 0": 93,
  },
  {
    Minutes: 19,
    Period: 2,
    Play_run: "catches and then drives to the right towards the basket shot blocked",
    Players: "Jaden Shackelford",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.18,
    SQ_Points: 0.37,
    SQ_Points_Over_Average: 0.0178509253,
    SQ_Points_percentile: 0.03,
    Seconds: 20,
    Team: "Alabama",
    "Unnamed: 0": 94,
  },
  {
    Minutes: 19,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: -0.103953559,
    SQ_Points_percentile: 0.28,
    Seconds: 14,
    Team: "Alabama",
    "Unnamed: 0": 95,
  },
  {
    Minutes: 18,
    Period: 2,
    Play_run: "post-up on the right block and drives to the basket fouled",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.7,
    SQ_Points: 1.41,
    SQ_Points_Over_Average: 0.0471053667,
    SQ_Points_percentile: 0.81,
    Seconds: 57,
    Team: "South Dakota St.",
    "Unnamed: 0": 96,
  },
  {
    Minutes: 18,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.26,
    SQ_Points: 0.78,
    SQ_Points_Over_Average: -0.0637581598,
    SQ_Points_percentile: 0.25,
    Seconds: 43,
    Team: "Alabama",
    "Unnamed: 0": 97,
  },
  {
    Minutes: 18,
    Period: 2,
    Play_run: "offensive rebound shot made",
    Players: "Keon Ellis",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.67,
    SQ_Points: 1.34,
    SQ_Points_Over_Average: 0.0070444281,
    SQ_Points_percentile: 0.77,
    Seconds: 36,
    Team: "Alabama",
    "Unnamed: 0": 98,
  },
  {
    Minutes: 18,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot missed",
    Players: "Alex Arians",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 0.76,
    SQ_Points_Over_Average: 0.0820879769,
    SQ_Points_percentile: 0.24,
    Seconds: 24,
    Team: "South Dakota St.",
    "Unnamed: 0": 99,
  },
  {
    Minutes: 18,
    Period: 2,
    Play_run: "transition catch and shoot 3 point shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.32,
    SQ_Points: 0.96,
    SQ_Points_Over_Average: -0.1038521664,
    SQ_Points_percentile: 0.44,
    Seconds: 14,
    Team: "Alabama",
    "Unnamed: 0": 100,
  },
  {
    Minutes: 17,
    Period: 2,
    Play_run: "turnover",
    Players: "Douglas Wilson",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 54,
    Team: "South Dakota St.",
    "Unnamed: 0": 101,
  },
  {
    Minutes: 17,
    Period: 2,
    Play_run: "pick and roll (roll-man) recieves pass and rolls to basket shot made and fouled",
    Players: "Charles Bediako",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.82,
    SQ_Points: 2.47,
    SQ_Points_Over_Average: -0.1088006489,
    SQ_Points_percentile: 0.98,
    Seconds: 46,
    Team: "Alabama",
    "Unnamed: 0": 102,
  },
  {
    Minutes: 17,
    Period: 2,
    Play_run: "turnover",
    Players: "Alex Arians",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 42,
    Team: "South Dakota St.",
    "Unnamed: 0": 103,
  },
  {
    Minutes: 17,
    Period: 2,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.34,
    SQ_Points_Over_Average: 0.1234476209,
    SQ_Points_percentile: 0.77,
    Seconds: 33,
    Team: "Alabama",
    "Unnamed: 0": 104,
  },
  {
    Minutes: 17,
    Period: 2,
    Play_run: "cut drop off pass at basket for layup shot made",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.72,
    SQ_Points: 1.44,
    SQ_Points_Over_Average: -0.0524838811,
    SQ_Points_percentile: 0.83,
    Seconds: 14,
    Team: "South Dakota St.",
    "Unnamed: 0": 105,
  },
  {
    Minutes: 16,
    Period: 2,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.34,
    SQ_Points: 1.01,
    SQ_Points_Over_Average: -0.2065523791,
    SQ_Points_percentile: 0.49,
    Seconds: 59,
    Team: "Alabama",
    "Unnamed: 0": 106,
  },
  {
    Minutes: 16,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 1.21,
    SQ_Points_Over_Average: 0.296046441,
    SQ_Points_percentile: 0.67,
    Seconds: 31,
    Team: "South Dakota St.",
    "Unnamed: 0": 107,
  },
  {
    Minutes: 16,
    Period: 2,
    Play_run: "offensive rebound shot made",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.62,
    SQ_Points: 1.24,
    SQ_Points_Over_Average: -0.0929555719,
    SQ_Points_percentile: 0.69,
    Seconds: 24,
    Team: "South Dakota St.",
    "Unnamed: 0": 108,
  },
  {
    Minutes: 16,
    Period: 2,
    Play_run: "pick and roll (roll-man) and then drives to the basket shot made and fouled",
    Players: "Darius Miles",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.84,
    SQ_Points: 2.52,
    SQ_Points_Over_Average: -0.1490871818,
    SQ_Points_percentile: 0.98,
    Seconds: 10,
    Team: "Alabama",
    "Unnamed: 0": 109,
  },
  {
    Minutes: 15,
    Period: 2,
    Play_run: "turnover",
    Players: "Douglas Wilson",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 59,
    Team: "South Dakota St.",
    "Unnamed: 0": 110,
  },
  {
    Minutes: 15,
    Period: 2,
    Play_run: "pick and roll (roll-man) recieves pass and rolls to basket shot missed",
    Players: "Charles Bediako",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.52,
    SQ_Points: 1.04,
    SQ_Points_Over_Average: 0.0166236976,
    SQ_Points_percentile: 0.52,
    Seconds: 38,
    Team: "Alabama",
    "Unnamed: 0": 111,
  },
  {
    Minutes: 15,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.46,
    SQ_Points: 0.91,
    SQ_Points_Over_Average: 0.2320879769,
    SQ_Points_percentile: 0.38,
    Seconds: 29,
    Team: "South Dakota St.",
    "Unnamed: 0": 112,
  },
  {
    Minutes: 15,
    Period: 2,
    Play_run: "catches and then drives to the right towards the basket shot missed",
    Players: "Jd Davison",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.41,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: 0.0718387103,
    SQ_Points_percentile: 0.28,
    Seconds: 4,
    Team: "Alabama",
    "Unnamed: 0": 113,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 1.21,
    SQ_Points_Over_Average: 0.296046441,
    SQ_Points_percentile: 0.67,
    Seconds: 50,
    Team: "South Dakota St.",
    "Unnamed: 0": 114,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: -0.103953559,
    SQ_Points_percentile: 0.28,
    Seconds: 39,
    Team: "Alabama",
    "Unnamed: 0": 115,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Zeke Mayo",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.78,
    SQ_Points: 1.56,
    SQ_Points_Over_Average: 0.1022417826,
    SQ_Points_percentile: 0.9,
    Seconds: 32,
    Team: "South Dakota St.",
    "Unnamed: 0": 116,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: -0.103953559,
    SQ_Points_percentile: 0.28,
    Seconds: 25,
    Team: "Alabama",
    "Unnamed: 0": 117,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "turnover",
    Players: "Baylor Scheierman",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 21,
    Team: "South Dakota St.",
    "Unnamed: 0": 118,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "runs off screen catch and shoot 3 point shot made and fouled",
    Players: "Jaden Shackelford",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.88,
    SQ_Points: 3.5,
    SQ_Points_Over_Average: -0.0055006483,
    SQ_Points_percentile: 1,
    Seconds: 17,
    Team: "Alabama",
    "Unnamed: 0": 119,
  },
  {
    Minutes: 14,
    Period: 2,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Matt Dentlinger",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.88,
    SQ_Points: 1.76,
    SQ_Points_Over_Average: 0.3022417826,
    SQ_Points_percentile: 0.94,
    Seconds: 10,
    Team: "South Dakota St.",
    "Unnamed: 0": 120,
  },
  {
    Minutes: 13,
    Period: 2,
    Play_run: "catches and then drives to the left towards the basket shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 0.71,
    SQ_Points_Over_Average: -0.0193883065,
    SQ_Points_percentile: 0.19,
    Seconds: 53,
    Team: "Alabama",
    "Unnamed: 0": 121,
  },
  {
    Minutes: 13,
    Period: 2,
    Play_run: "catch and shoot 3 point fouled",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.84,
    SQ_Points: 2.52,
    SQ_Points_Over_Average: 0.0886553214,
    SQ_Points_percentile: 0.98,
    Seconds: 42,
    Team: "South Dakota St.",
    "Unnamed: 0": 122,
  },
  {
    Minutes: 13,
    Period: 2,
    Play_run: "catches and then drives to the left towards the basket shot missed",
    Players: "Keon Ellis",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.44,
    SQ_Points: 0.89,
    SQ_Points_Over_Average: 0.1606116935,
    SQ_Points_percentile: 0.36,
    Seconds: 25,
    Team: "Alabama",
    "Unnamed: 0": 123,
  },
  {
    Minutes: 13,
    Period: 2,
    Play_run: "turnover",
    Players: "Keon Ambrose-Hylton",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 23,
    Team: "Alabama",
    "Unnamed: 0": 124,
  },
  {
    Minutes: 12,
    Period: 2,
    Play_run: "catches and then drives to the left towards the basket shot made",
    Players: "Zeke Mayo",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.48,
    SQ_Points: 0.97,
    SQ_Points_Over_Average: 0.0025117443,
    SQ_Points_percentile: 0.45,
    Seconds: 59,
    Team: "South Dakota St.",
    "Unnamed: 0": 125,
  },
  {
    Minutes: 12,
    Period: 2,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.47,
    SQ_Points: 0.94,
    SQ_Points_Over_Average: -0.0719609983,
    SQ_Points_percentile: 0.41,
    Seconds: 46,
    Team: "Alabama",
    "Unnamed: 0": 126,
  },
  {
    Minutes: 12,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 1.21,
    SQ_Points_Over_Average: 0.296046441,
    SQ_Points_percentile: 0.67,
    Seconds: 26,
    Team: "South Dakota St.",
    "Unnamed: 0": 127,
  },
  {
    Minutes: 12,
    Period: 2,
    Play_run: "turnover",
    Players: "Jd Davison",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 8,
    Team: "Alabama",
    "Unnamed: 0": 128,
  },
  {
    Minutes: 12,
    Period: 2,
    Play_run: "transition and then drives to the basket shot made and fouled",
    Players: "Zeke Mayo",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.88,
    SQ_Points: 2.65,
    SQ_Points_Over_Average: 0.1488540511,
    SQ_Points_percentile: 1,
    Seconds: 3,
    Team: "South Dakota St.",
    "Unnamed: 0": 129,
  },
  {
    Minutes: 11,
    Period: 2,
    Play_run: "pick and roll (roll-man) pick and pop and drives to the basket shot made",
    Players: "Noah Gurley",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.62,
    SQ_Points: 1.23,
    SQ_Points_Over_Average: 0.2629559004,
    SQ_Points_percentile: 0.69,
    Seconds: 52,
    Team: "Alabama",
    "Unnamed: 0": 130,
  },
  {
    Minutes: 11,
    Period: 2,
    Play_run: "hand-off off the dribble short midrange jumper shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 1.01,
    SQ_Points_Over_Average: 0.1369322522,
    SQ_Points_percentile: 0.49,
    Seconds: 35,
    Team: "South Dakota St.",
    "Unnamed: 0": 131,
  },
  {
    Minutes: 11,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jd Davison",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.32,
    SQ_Points: 0.97,
    SQ_Points_Over_Average: -0.0917282287,
    SQ_Points_percentile: 0.45,
    Seconds: 25,
    Team: "Alabama",
    "Unnamed: 0": 132,
  },
  {
    Minutes: 11,
    Period: 2,
    Play_run: "offensive rebound shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.69,
    SQ_Points: 1.38,
    SQ_Points_Over_Average: 0.0470444281,
    SQ_Points_percentile: 0.8,
    Seconds: 19,
    Team: "Alabama",
    "Unnamed: 0": 133,
  },
  {
    Minutes: 11,
    Period: 2,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Alex Arians",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.35,
    SQ_Points_Over_Average: 0.3009016404,
    SQ_Points_percentile: 0.78,
    Seconds: 7,
    Team: "South Dakota St.",
    "Unnamed: 0": 134,
  },
  {
    Minutes: 10,
    Period: 2,
    Play_run: "pick and roll (roll-man) pick and pop 3 point shot made",
    Players: "Noah Gurley",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.37,
    SQ_Points: 1.11,
    SQ_Points_Over_Average: -0.0535771903,
    SQ_Points_percentile: 0.58,
    Seconds: 51,
    Team: "Alabama",
    "Unnamed: 0": 135,
  },
  {
    Minutes: 10,
    Period: 2,
    Play_run: "isolation off the dribble 3 point shot made",
    Players: "Zeke Mayo",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 1.15,
    SQ_Points_Over_Average: 0.1644883142,
    SQ_Points_percentile: 0.62,
    Seconds: 20,
    Team: "South Dakota St.",
    "Unnamed: 0": 136,
  },
  {
    Minutes: 10,
    Period: 2,
    Play_run: "cut drop off pass at basket for layup shot made",
    Players: "Jd Davison",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.75,
    SQ_Points: 1.5,
    SQ_Points_Over_Average: 0.0075161189,
    SQ_Points_percentile: 0.87,
    Seconds: 6,
    Team: "Alabama",
    "Unnamed: 0": 137,
  },
  {
    Minutes: 9,
    Period: 2,
    Play_run: "hand-off off the dribble 3 point shot missed",
    Players: "Baylor Scheierman",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 1.09,
    SQ_Points_Over_Average: 0.3010138185,
    SQ_Points_percentile: 0.57,
    Seconds: 43,
    Team: "South Dakota St.",
    "Unnamed: 0": 138,
  },
  {
    Minutes: 9,
    Period: 2,
    Play_run: "offensive rebound shot missed",
    Players: "Zeke Mayo",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.44,
    SQ_Points: 0.87,
    SQ_Points_Over_Average: -0.1629555719,
    SQ_Points_percentile: 0.34,
    Seconds: 37,
    Team: "South Dakota St.",
    "Unnamed: 0": 139,
  },
  {
    Minutes: 9,
    Period: 2,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Jd Davison",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.76,
    SQ_Points: 1.52,
    SQ_Points_Over_Average: 0.0622417826,
    SQ_Points_percentile: 0.88,
    Seconds: 31,
    Team: "Alabama",
    "Unnamed: 0": 140,
  },
  {
    Minutes: 9,
    Period: 2,
    Play_run: "catches and then drives to the right towards the basket shot blocked",
    Players: "Baylor Scheierman",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.17,
    SQ_Points: 0.35,
    SQ_Points_Over_Average: -0.0021490747,
    SQ_Points_percentile: 0.03,
    Seconds: 14,
    Team: "South Dakota St.",
    "Unnamed: 0": 141,
  },
  {
    Minutes: 9,
    Period: 2,
    Play_run: "transition catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.3,
    SQ_Points: 0.89,
    SQ_Points_Over_Average: -0.1864820355,
    SQ_Points_percentile: 0.36,
    Seconds: 7,
    Team: "Alabama",
    "Unnamed: 0": 142,
  },
  {
    Minutes: 8,
    Period: 2,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Keon Ellis",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.44,
    SQ_Points: 1.33,
    SQ_Points_Over_Average: 0.1134476209,
    SQ_Points_percentile: 0.77,
    Seconds: 54,
    Team: "Alabama",
    "Unnamed: 0": 143,
  },
  {
    Minutes: 8,
    Period: 2,
    Play_run: "post-up on the right block shot blocked",
    Players: "Luke Appel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.21,
    SQ_Points: 0.42,
    SQ_Points_Over_Average: -0.0544370565,
    SQ_Points_percentile: 0.04,
    Seconds: 34,
    Team: "South Dakota St.",
    "Unnamed: 0": 144,
  },
  {
    Minutes: 8,
    Period: 2,
    Play_run: "cut drop off pass at basket for layup shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.74,
    SQ_Points: 1.49,
    SQ_Points_Over_Average: -0.0024838811,
    SQ_Points_percentile: 0.86,
    Seconds: 13,
    Team: "Alabama",
    "Unnamed: 0": 145,
  },
  {
    Minutes: 7,
    Period: 2,
    Play_run: "cut drop off pass at basket for layup shot blocked",
    Players: "Douglas Wilson",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.18,
    SQ_Points: 0.36,
    SQ_Points_Over_Average: -0.0858619946,
    SQ_Points_percentile: 0.03,
    Seconds: 57,
    Team: "South Dakota St.",
    "Unnamed: 0": 146,
  },
  {
    Minutes: 7,
    Period: 2,
    Play_run: "pick and roll (roll-man) recieves pass and rolls to basket shot made and fouled",
    Players: "Charles Bediako",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.82,
    SQ_Points: 2.47,
    SQ_Points_Over_Average: -0.1088006489,
    SQ_Points_percentile: 0.98,
    Seconds: 44,
    Team: "Alabama",
    "Unnamed: 0": 147,
  },
  {
    Minutes: 7,
    Period: 2,
    Play_run: "pick and roll (roll-man) recieves pass and rolls to basket shot made and fouled",
    Players: "Douglas Wilson",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.88,
    SQ_Points: 2.65,
    SQ_Points_Over_Average: 0.0911993511,
    SQ_Points_percentile: 1,
    Seconds: 36,
    Team: "South Dakota St.",
    "Unnamed: 0": 148,
  },
  {
    Minutes: 7,
    Period: 2,
    Play_run: "single bonus",
    Players: "Keon Ellis",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.75,
    SQ_Points: 1.5,
    SQ_Points_Over_Average: 0.2296887582,
    SQ_Points_percentile: 0.87,
    Seconds: 8,
    Team: "Alabama",
    "Unnamed: 0": 149,
  },
  {
    Minutes: 6,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 0.99,
    SQ_Points_Over_Average: 0.0974901227,
    SQ_Points_percentile: 0.47,
    Seconds: 53,
    Team: "South Dakota St.",
    "Unnamed: 0": 150,
  },
  {
    Minutes: 6,
    Period: 2,
    Play_run: "catch and shoot 3 point shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.34,
    SQ_Points: 1.01,
    SQ_Points_Over_Average: -0.2065523791,
    SQ_Points_percentile: 0.49,
    Seconds: 37,
    Team: "Alabama",
    "Unnamed: 0": 151,
  },
  {
    Minutes: 6,
    Period: 2,
    Play_run: "pick and roll (ball-handler) and then drives to the basket fouled",
    Players: "Baylor Scheierman",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.76,
    SQ_Points: 1.53,
    SQ_Points_Over_Average: 0.1463657973,
    SQ_Points_percentile: 0.89,
    Seconds: 26,
    Team: "South Dakota St.",
    "Unnamed: 0": 152,
  },
  {
    Minutes: 6,
    Period: 2,
    Play_run: "isolation drives to the left towards the basket fouled",
    Players: "Jd Davison",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.68,
    SQ_Points: 1.35,
    SQ_Points_Over_Average: -0.007176881,
    SQ_Points_percentile: 0.78,
    Seconds: 8,
    Team: "Alabama",
    "Unnamed: 0": 153,
  },
  {
    Minutes: 5,
    Period: 2,
    Play_run: "catches and then takes off the dribble 3 point shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.4,
    SQ_Points: 1.19,
    SQ_Points_Over_Average: 0.2217929529,
    SQ_Points_percentile: 0.65,
    Seconds: 57,
    Team: "South Dakota St.",
    "Unnamed: 0": 154,
  },
  {
    Minutes: 5,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.27,
    SQ_Points: 0.81,
    SQ_Points_Over_Average: -0.103953559,
    SQ_Points_percentile: 0.28,
    Seconds: 44,
    Team: "Alabama",
    "Unnamed: 0": 155,
  },
  {
    Minutes: 5,
    Period: 2,
    Play_run: "transition and then drives to the basket shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.74,
    SQ_Points: 1.49,
    SQ_Points_Over_Average: 0.0322417826,
    SQ_Points_percentile: 0.86,
    Seconds: 37,
    Team: "South Dakota St.",
    "Unnamed: 0": 156,
  },
  {
    Minutes: 5,
    Period: 2,
    Play_run: "pick and roll (roll-man) catch and shoot 3 point shot missed",
    Players: "Darius Miles",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.31,
    SQ_Points: 0.93,
    SQ_Points_Over_Average: 0.0413560187,
    SQ_Points_percentile: 0.4,
    Seconds: 25,
    Team: "Alabama",
    "Unnamed: 0": 157,
  },
  {
    Minutes: 5,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper fouled",
    Players: "Baylor Scheierman",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.81,
    SQ_Points: 1.63,
    SQ_Points_Over_Average: 0.2299325096,
    SQ_Points_percentile: 0.92,
    Seconds: 18,
    Team: "South Dakota St.",
    "Unnamed: 0": 158,
  },
  {
    Minutes: 5,
    Period: 2,
    Play_run: "catches and then drives to the right towards the basket fouled",
    Players: "Keon Ellis",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.72,
    SQ_Points: 1.45,
    SQ_Points_Over_Average: 0.1352210035,
    SQ_Points_percentile: 0.84,
    Seconds: 3,
    Team: "Alabama",
    "Unnamed: 0": 159,
  },
  {
    Minutes: 4,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble short midrange jumper shot missed",
    Players: "Noah Freidel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.38,
    SQ_Points: 0.75,
    SQ_Points_Over_Average: 0.0720879769,
    SQ_Points_percentile: 0.23,
    Seconds: 50,
    Team: "South Dakota St.",
    "Unnamed: 0": 160,
  },
  {
    Minutes: 4,
    Period: 2,
    Play_run: "offensive rebound shot made",
    Players: "Charlie Easley",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.55,
    SQ_Points: 1.1,
    SQ_Points_Over_Average: -0.2329555719,
    SQ_Points_percentile: 0.58,
    Seconds: 44,
    Team: "South Dakota St.",
    "Unnamed: 0": 161,
  },
  {
    Minutes: 4,
    Period: 2,
    Play_run: "pick and roll (roll-man) catch and shoot 3 point shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 1.07,
    SQ_Points_Over_Average: 0.046211218,
    SQ_Points_percentile: 0.55,
    Seconds: 34,
    Team: "Alabama",
    "Unnamed: 0": 162,
  },
  {
    Minutes: 4,
    Period: 2,
    Play_run: "runs off screen catch and shoot 3 point fouled",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.83,
    SQ_Points: 2.48,
    SQ_Points_Over_Average: 0.0855009205,
    SQ_Points_percentile: 0.98,
    Seconds: 20,
    Team: "South Dakota St.",
    "Unnamed: 0": 163,
  },
  {
    Minutes: 4,
    Period: 2,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.56,
    SQ_Points: 1.12,
    SQ_Points_Over_Average: 0.0901653776,
    SQ_Points_percentile: 0.59,
    Seconds: 9,
    Team: "Alabama",
    "Unnamed: 0": 164,
  },
  {
    Minutes: 4,
    Period: 2,
    Play_run: "turnover",
    Players: "Noah Freidel",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0,
    SQ_Points: 0,
    SQ_Points_Over_Average: 0,
    SQ_Points_percentile: 0,
    Seconds: 3,
    Team: "South Dakota St.",
    "Unnamed: 0": 165,
  },
  {
    Minutes: 3,
    Period: 2,
    Play_run: "isolation catch and shoot 3 point shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.32,
    SQ_Points: 0.96,
    SQ_Points_Over_Average: 0.0278321198,
    SQ_Points_percentile: 0.44,
    Seconds: 47,
    Team: "Alabama",
    "Unnamed: 0": 166,
  },
  {
    Minutes: 3,
    Period: 2,
    Play_run: "double bonus",
    Players: "Baylor Scheierman",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.78,
    SQ_Points: 1.57,
    SQ_Points_Over_Average: 0.1633706448,
    SQ_Points_percentile: 0.9,
    Seconds: 38,
    Team: "South Dakota St.",
    "Unnamed: 0": 167,
  },
  {
    Minutes: 3,
    Period: 2,
    Play_run: "runs off screen and then drives to the basket fouled",
    Players: "Jaden Shackelford",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.7,
    SQ_Points: 1.41,
    SQ_Points_Over_Average: -0.0323966416,
    SQ_Points_percentile: 0.81,
    Seconds: 26,
    Team: "Alabama",
    "Unnamed: 0": 168,
  },
  {
    Minutes: 3,
    Period: 2,
    Play_run: "off the dribble short midrange jumper shot made",
    Players: "Baylor Scheierman",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.62,
    SQ_Points: 1.25,
    SQ_Points_Over_Average: 0.3064011479,
    SQ_Points_percentile: 0.7,
    Seconds: 17,
    Team: "South Dakota St.",
    "Unnamed: 0": 169,
  },
  {
    Minutes: 3,
    Period: 2,
    Play_run: "isolation drives to the right towards the basket shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.56,
    SQ_Points: 1.12,
    SQ_Points_Over_Average: 0.151446716,
    SQ_Points_percentile: 0.59,
    Seconds: 1,
    Team: "Alabama",
    "Unnamed: 0": 170,
  },
  {
    Minutes: 2,
    Period: 2,
    Play_run: "isolation off the dribble 3 point shot made",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.45,
    SQ_Points: 1.35,
    SQ_Points_Over_Average: 0.3175231011,
    SQ_Points_percentile: 0.78,
    Seconds: 45,
    Team: "South Dakota St.",
    "Unnamed: 0": 171,
  },
  {
    Minutes: 2,
    Period: 2,
    Play_run: "catches and then drives to the right towards the basket shot missed",
    Players: "Darius Miles",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.32,
    SQ_Points: 0.64,
    SQ_Points_Over_Average: -0.0981612897,
    SQ_Points_percentile: 0.13,
    Seconds: 20,
    Team: "Alabama",
    "Unnamed: 0": 172,
  },
  {
    Minutes: 2,
    Period: 2,
    Play_run: "offensive rebound shot missed",
    Players: "Darius Miles",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 0.99,
    SQ_Points_Over_Average: -0.0429555719,
    SQ_Points_percentile: 0.47,
    Seconds: 14,
    Team: "Alabama",
    "Unnamed: 0": 173,
  },
  {
    Minutes: 2,
    Period: 2,
    Play_run: "offensive rebound shot made",
    Players: "Darius Miles",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.64,
    SQ_Points: 1.29,
    SQ_Points_Over_Average: -0.0429555719,
    SQ_Points_percentile: 0.74,
    Seconds: 11,
    Team: "Alabama",
    "Unnamed: 0": 174,
  },
  {
    Minutes: 2,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "David Wingett",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.36,
    SQ_Points: 1.09,
    SQ_Points_Over_Average: 0.176046441,
    SQ_Points_percentile: 0.57,
    Seconds: 0,
    Team: "South Dakota St.",
    "Unnamed: 0": 175,
  },
  {
    Minutes: 1,
    Period: 2,
    Play_run: "catches and then takes off the dribble 3 point shot missed",
    Players: "Jaden Shackelford",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.28,
    SQ_Points: 0.84,
    SQ_Points_Over_Average: 0.0685769307,
    SQ_Points_percentile: 0.31,
    Seconds: 31,
    Team: "Alabama",
    "Unnamed: 0": 176,
  },
  {
    Minutes: 1,
    Period: 2,
    Play_run: "offensive rebound shot missed",
    Players: "Darius Miles",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.5,
    SQ_Points: 0.99,
    SQ_Points_Over_Average: -0.0429555719,
    SQ_Points_percentile: 0.47,
    Seconds: 26,
    Team: "Alabama",
    "Unnamed: 0": 177,
  },
  {
    Minutes: 1,
    Period: 2,
    Play_run: "offensive rebound shot made",
    Players: "Jaden Shackelford",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.69,
    SQ_Points: 1.38,
    SQ_Points_Over_Average: 0.0470444281,
    SQ_Points_percentile: 0.8,
    Seconds: 23,
    Team: "Alabama",
    "Unnamed: 0": 178,
  },
  {
    Minutes: 1,
    Period: 2,
    Play_run: "transition catch and shoot 3 point shot made",
    Players: "Charlie Easley",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.55,
    SQ_Points: 1.66,
    SQ_Points_Over_Average: 0.4286938142,
    SQ_Points_percentile: 0.93,
    Seconds: 19,
    Team: "South Dakota St.",
    "Unnamed: 0": 179,
  },
  {
    Minutes: 0,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Bad Possession",
    SQ_FG_Percentage: 0.29,
    SQ_Points: 0.87,
    SQ_Points_Over_Average: -0.1917282287,
    SQ_Points_percentile: 0.34,
    Seconds: 58,
    Team: "Alabama",
    "Unnamed: 0": 180,
  },
  {
    Minutes: 0,
    Period: 2,
    Play_run: "pick and roll (ball-handler) and then drives to the basket shot made",
    Players: "Jahvon Quinerly",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.56,
    SQ_Points: 1.12,
    SQ_Points_Over_Average: 0.0901653776,
    SQ_Points_percentile: 0.59,
    Seconds: 35,
    Team: "Alabama",
    "Unnamed: 0": 181,
  },
  {
    Minutes: 0,
    Period: 2,
    Play_run: "catch and shoot 3 point shot missed",
    Players: "Noah Freidel",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.44,
    SQ_Points: 1.31,
    SQ_Points_Over_Average: 0.2482717713,
    SQ_Points_percentile: 0.75,
    Seconds: 23,
    Team: "South Dakota St.",
    "Unnamed: 0": 182,
  },
  {
    Minutes: 0,
    Period: 2,
    Play_run: "double bonus",
    Players: "Jaden Shackelford",
    Possession_Quality: "Good Possession",
    SQ_FG_Percentage: 0.76,
    SQ_Points: 1.53,
    SQ_Points_Over_Average: 0.1899018059,
    SQ_Points_percentile: 0.89,
    Seconds: 17,
    Team: "Alabama",
    "Unnamed: 0": 183,
  },
  {
    Minutes: 0,
    Period: 2,
    Play_run: "pick and roll (ball-handler) off the dribble 3 point shot missed",
    Players: "Zeke Mayo",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.33,
    SQ_Points: 1,
    SQ_Points_Over_Average: 0.1562418402,
    SQ_Points_percentile: 0.48,
    Seconds: 4,
    Team: "South Dakota St.",
    "Unnamed: 0": 184,
  },
  {
    Minutes: 0,
    Period: 2,
    Play_run: "offensive rebound 3 point shot missed",
    Players: "David Wingett",
    Possession_Quality: "Neutral Possession",
    SQ_FG_Percentage: 0.3,
    SQ_Points: 0.91,
    SQ_Points_Over_Average: -0.0135333211,
    SQ_Points_percentile: 0.38,
    Seconds: 0,
    Team: "South Dakota St.",
    "Unnamed: 0": 185,
  },
];

export const teamScoreSummaryHeader = [
  {
    title: "Logos",
    showImage: false,
    sortable: false,
    key: "logos",
  },
  {
    title: "Players",
    showImage: false,
    sortable: false,
    key: "Players",
  },
  {
    title: "Possessions",
    showImage: false,
    sortable: false,
    key: "Possessions",
  },
  {
    title: "Points",
    showImage: false,
    sortable: false,
    key: "Points",
  },
  {
    title: "SQ Points",
    showImage: false,
    sortable: false,
    key: "SQ_Points",
  },
  {
    title: "SQ PPP",
    showImage: false,
    sortable: false,
    key: "SQ_PPP",
    tooltip: {
      title: "Shot Quality Points per Possession",
      text: "Total SQ points scored divided by total possession.",
      link: "/stats-explained#sq-points",
    },
  },
  {
    title: "SQ PPP Rank",
    showImage: true,
    sortable: false,
    key: "Percentile_graph",
    tooltip: {
      title: "SQ Points per Possession Percentile Rank",
      text: "Player's percentile rank in all NCAA.",
    },
  },
  {
    title: "Good Possessions",
    showImage: false,
    sortable: true,
    key: "GoodPossessions",
    tooltip: {
      title: "Good Possession",
      text: "Possessions that are in the 66th percentile of SQ Points or above. The 66th percentile is 1.24 SQ Points",
      link: "/stats-explained#good-possessions",
    },
  },
  {
    title: "Bad Possessions",
    showImage: false,
    sortable: true,
    key: "BadPossessions",
    tooltip: {
      title: "Bad Possession",
      text: "Possessions that are in the 33rd percentile of SQ Points or below. The 33rd percentile is .77 SQ Points",
      link: "/stats-explained#bad-possessions",
    },
  },
  {
    title: "Assists",
    showImage: false,
    sortable: false,
    key: "Assists",
  },
  {
    title: "SQ Assists",
    showImage: false,
    sortable: false,
    key: "SQ_Assists",
    tooltip: {
      title: "Shot Quality Assists",
      text: "Analyzed every pass and calculated the probability that each shot would go in, and would therefore be an assist.",
      link: "/stats-explained#passing-stats",
    },
  },
  {
    title: "SQ Passing Points Created",
    showImage: false,
    sortable: false,
    key: "SQ_Passing_Points_Created",
    tooltip: {
      title: "Shot Quality Passing Points Created",
      text: "Tracks every pass and sums up the SQ points that were accumulated from each pass. Dispells of all biases polluting convetional assist stat.",
      link: "/stats-explained#passing-stats",
    },
  },
];

export const halfCourtTable = [
  {
    title: "Team",
    showImage: false,
    sortable: false,
    key: "Teams",
  },
  {
    title: "Poss",
    showImage: false,
    sortable: false,
    key: "Half_Court_Poss",
  },
  {
    title: "SQ PPP",
    showImage: false,
    sortable: false,
    key: "Half_Court_SQ_PPP",
  },
  {
    title: "SQ PPP Percentile",
    showImage: false,
    sortable: false,
    key: "Half_Court_SQ_PPP_Percentile",
  },
];

export const transitionTable = [
  {
    title: "Team",
    showImage: false,
    sortable: false,
    key: "Teams",
  },
  {
    title: "Poss",
    showImage: false,
    sortable: false,
    key: "Transition_Poss",
  },
  {
    title: "SQ PPP",
    showImage: false,
    sortable: false,
    key: "Transition_SQ_PPP",
  },
  {
    title: "SQ PPP Percentile",
    showImage: false,
    sortable: false,
    key: "Transition_SQ_PPP_Percentile",
  },
];

export const finalScoreHeader = [
  {
    title: "Teams",
    showImage: false,
    sortable: false,
    key: "Teams",
  },
  {
    title: "Scores",
    showImage: false,
    sortable: false,
    key: "Scores",
  },
  {
    title: "Team SQ Points",
    showImage: false,
    sortable: false,
    key: "Team_SQ_Points",
    tooltip: {
      title: "Team SQ Points",
      text: "Values the entire possession (multiple offensive boards), while the player SQ Points is just individual shots. Therefore, the accumulation is different from the SQ Points total below",
      link: "/stats-explained#sq-points",
    },
  },
  {
    title: "Team SQ PPP",
    showImage: false,
    sortable: false,
    key: "SQ_PPP",
    tooltip: {
      title: "Team SQ PPP",
      text: "Divides Team SQ Points by Team Possessions.",
      link: "/stats-explained#sq-points",
    },
  },
  {
    title: "SQ PPP Rank",
    showImage: false,
    sortable: false,
    key: "SQ_PPP_RANK",
    tooltip: {
      title: "SQ PPP Rank",
      text: "Percentile rank compared to NCAA in this game.",
    },
  },
];

export const teamTendencyHeader = [
  { title: "Category", showImage: false, sortable: false, key: "Category" },
  {
    title: "SQ Points",
    showImage: false,
    sortable: false,
    key: "SQ_Points",
  },
  {
    title: "Actual",
    showImage: false,
    sortable: false,
    key: "Actual",
  },
  {
    title: "Difference",
    showImage: false,
    sortable: false,
    key: "Difference",
  },
];

export const teamStatsHeader = [
  {
    title: "Category Name",
    showImage: false,
    sortable: false,
    key: "Category_Name",
  },
  {
    title: "SQ PPP",
    showImage: false,
    sortable: false,
    key: "SQ_PPP",
  },
  // {
  //   title: 'Season SQ PPP',
  //   showImage: false,
  //   sortable: false,
  //   key: 'Season_SQ_PPP',
  // },
  {
    title: `Frequency`,
    showImage: false,
    sortable: false,
    key: `Frequency`,
  },
  {
    title: "Count",
    showImage: false,
    sortable: false,
    key: "Count",
  },
];

export const playsRanHeader = [
  {
    title: "Team",
    showImage: false,
    sortable: false,
    key: "Team",
  },
  {
    title: "Play Ran",
    showImage: false,
    sortable: false,
    key: "Play_Ran",
  },
  {
    title: "Occurrences",
    showImage: false,
    sortable: false,
    key: "Occurrences",
  },
  {
    title: "SQ PPP",
    showImage: false,
    sortable: false,
    key: "SQ.PPP",
    tooltip: {
      title: "Shot Quality Points Per Possession",
      text: "Total SQ points scored divided by total possessions",
    },
  },
];
